/**
 * Key Drivers / Pivony Insight (metric 23): plain-text tab body with labeled sections.
 * Must stay in sync with `parseInsightSections` usage in PivonyInsightWidget.js.
 */

export function parseKeyDriverTabPlainText(rawText) {
  const text = String(rawText || "").trim();
  if (!text) {
    return { critical: "", meaning: "", action: "" };
  }
  const findSection = (regexList) => {
    for (let i = 0; i < regexList.length; i += 1) {
      const rx = regexList[i];
      const match = text.match(rx);
      if (match && match[1]) return String(match[1]).trim();
    }
    return "";
  };
  const finding = findSection([
    /k(?:r|ri)t(?:i|ı)k(?:\s+teknik)?\s+bulgu[:\-\s]*([\s\S]*?)(?=\n\s*(?:ne\s+anlama\s+geliyor|onerilen\s+aksiyon|action)\b|$)/i,
    /critical\s+finding[:\-\s]*([\s\S]*?)(?=\n\s*(?:meaning|action)\b|$)/i,
  ]);
  const meaning = findSection([
    /ne\s+anlama\s+geliyor\??[:\-\s]*([\s\S]*?)(?=\n\s*(?:onerilen\s+aksiyon|action)\b|$)/i,
    /meaning[:\-\s]*([\s\S]*?)(?=\n\s*(?:action)\b|$)/i,
  ]);
  const action = findSection([
    /onerilen\s+aksiyon[:\-\s]*([\s\S]*?)$/i,
    /action[:\-\s]*([\s\S]*?)$/i,
  ]);
  if (finding || meaning || action) {
    return { critical: finding, meaning, action };
  }
  return { critical: text, meaning: "", action: "" };
}

/** Round-trip labels aligned with LLM / parseKeyDriverTabPlainText. */
export function serializeKeyDriverTabPlainText({ critical, meaning, action }) {
  const c = String(critical ?? "").trim();
  const m = String(meaning ?? "").trim();
  const a = String(action ?? "").trim();
  const parts = [];
  if (c) {
    parts.push(`Kritik Teknik Bulgu: ${c}`);
  }
  if (m) {
    parts.push(`Ne Anlama Geliyor?: ${m}`);
  }
  if (a) {
    parts.push(`Önerilen Aksiyon: ${a}`);
  }
  return parts.join("\n\n");
}

/**
 * For PivonyInsightWidget: { finding, meaning, action } naming.
 */
export function parseInsightSectionsFromPlainText(rawText) {
  const { critical, meaning, action } = parseKeyDriverTabPlainText(rawText);
  if (critical || meaning || action) {
    return { finding: critical, meaning, action };
  }
  const t = String(rawText || "").trim();
  return { finding: t, meaning: "", action: "" };
}
